import BaseEntity from '../base/BaseEntity';
import Filter from '../base/filter/Filter';
import HttpUtil from '../../util/HttpUtil';
import InputFilter from '../base/filter/InputFilter';
import SortFilter from '../base/filter/SortFilter';
import CheckFilter from '../base/filter/CheckFilter';
import SelectionFilter from '../base/filter/SelectionFilter';
import User from '../user/User';
import Space from '../space/Space';
import SafeUtil from '../../util/SafeUtil';
import EnvUtil from '../../util/EnvUtil';
import DateUtil from '../../util/DateUtil';
import Lang from '../global/Lang';

// 操作类型常量
export enum LogOperation {
  UPLOAD = 'upload',
  UPLOAD_BLOCKED = "upload_blocked",
  DELETE = 'delete',
  SOFT_DELETE = 'soft_delete',
  RECOVERY = 'recovery',
  DOWNLOAD = 'download',
  DOWNLOAD_BLOCKED = "download_blocked",
  RENAME = 'rename',
  MOVE = 'move',
  COPY = 'copy',
  CREATE_DIRECTORY = 'create_directory',
  CHANGE_PRIVACY = 'change_privacy',
  OUTSEND_APPLY = 'outsend_apply',
  APPROVAL = 'approval',
  FORWARD = 'forward',
  UPLOAD_SKIPPED ='UPLOAD_SKIPPED',
  // 文件同步相关操作
  SYNC_SUCCESS = 'sync_success',
  SYNC_FAILED = 'sync_failed',
  SYNC_RECEIVED = 'SYNC_RECEIVED',
  OUTSEND_SYNC_SUCCESS = 'outsend_sync_success',  // 新增：外发同步成功
  OUTSEND_SYNC_FAILED = 'outsend_sync_failed',     // 新增：外发同步失败
	SYNC_SKIPPED   = "SYNC_SKIPPED" ,  // 同步跳过（文件已存在）

  // 文件分享权限相关操作
  SET_PUBLIC_READONLY = 'set_public_readonly',
  SET_PUBLIC_FULL = 'set_public_full',
  SET_PRIVATE_READONLY = 'set_private_readonly',
  SET_PRIVATE_FULL = 'set_private_full',
  REMOVE_SHARE = 'remove_share',
  PREVIEW_SHARE_FILE = 'preview_share_file',

  // 分享查看相关操作类型（根据实际需要保留或删除）
  VIEW_PUBLIC_SHARE_DETAIL = 'view_public_share_detail',
  VIEW_PRIVATE_SHARE_OWNER = 'view_private_share_owner',
  VIEW_PRIVATE_SHARE_TARGET = 'view_private_share_target',
  VIEW_MY_SHARES = 'view_my_shares',
  VIEW_SHARES_SHARED_TO_ME = 'view_shares_shared_to_me',
  BROWSE_SHARE = 'browse_share',
  DOWNLOAD_SHARE_ZIP = 'download_share_zip',
  BROWSE_SHARE_FILES = 'browse_share_files',
  DOWNLOAD_SHARE_FILE = 'download_share_file'  // 修正拼写错误：DOWN_LOAD_SHARE_FILE → DOWNLOAD_SHARE_FILE
}
// 目标类型常量
export enum LogTargetType {
  MATTER = 'matter',
  DIRECTORY = 'directory',
  SHARE = 'share',
}

export default class Log extends BaseEntity {
  userUuid: string = '';
  username: string = '';
  spaceUuid: string = '';
  spaceName: string = '';
  operation: string = '';
  targetType: string = '';
  targetUuid: string = '';
  targetName: string = '';
  detail: string = '';
  ip: string = '';
  userAgent: string = '';
  OPKindList: LogOperation=LogOperation.UPLOAD;
  // 关联的用户信息
  user: User = new User();
  // 关联的空间信息
  space: Space = new Space();

  /*
  这部分是辅助UI的字段信息
   */
  // 作为勾选变量
  check: boolean = false;
  // 操作类型显示文本
  operationText: string = '';
  // 目标类型显示文本
  targetTypeText: string = '';

  constructor(reactComponent?: React.Component) {
    super(reactComponent);
  }

  assign(obj: any) {
    super.assign(obj);
    this.assignEntity('user', User);
    this.assignEntity('space', Space);
    this.assignEntity('createTime', Date);
    
    // 设置操作类型和目标类型的显示文本
    this.operationText = this.getOperationText(this.operation);
    this.targetTypeText = this.getTargetTypeText(this.targetType);
  }

  getTAG(): string {
    return 'log';
  }

  getForm(): any {
    return {
      userUuid: this.userUuid,
      username: this.username,
      spaceUuid: this.spaceUuid,
      spaceName: this.spaceName,
      operation: this.operation,
      targetType: this.targetType,
      targetUuid: this.targetUuid,
      targetName: this.targetName,
      detail: this.detail,
      ip: this.ip,
      userAgent: this.userAgent,
    };
  }

// 获取操作类型的中文显示
getOperationText(operation: string): string {
  const operationMap: { [key: string]: string } = {
    [LogOperation.UPLOAD]: Lang.t('log.upload'),
    [LogOperation.UPLOAD_BLOCKED]: Lang.t('log.upload_blocked'),
    [LogOperation.DELETE]: Lang.t('log.delete'),
    [LogOperation.SOFT_DELETE]: Lang.t('log.softDelete'),
    [LogOperation.RECOVERY]: Lang.t('log.recovery'),
    [LogOperation.DOWNLOAD]: Lang.t('log.download'),
    [LogOperation.DOWNLOAD_BLOCKED]: Lang.t('log.download_blocked'),
    [LogOperation.RENAME]: Lang.t('log.rename'),
    [LogOperation.MOVE]: Lang.t('log.move'),
    [LogOperation.COPY]: Lang.t('log.copy'),
    [LogOperation.CREATE_DIRECTORY]: Lang.t('log.createDirectory'),
    [LogOperation.CHANGE_PRIVACY]: Lang.t('log.change_privacy'),
    [LogOperation.OUTSEND_APPLY]: Lang.t('log.outsend_apply'),
    [LogOperation.APPROVAL]: Lang.t('log.approval'),
    [LogOperation.FORWARD]: Lang.t('log.forward'),
    [LogOperation.UPLOAD_SKIPPED]: Lang.t('log.uploadskip'),
    // 文件同步相关操作
    [LogOperation.SYNC_SUCCESS]: Lang.t('log.sync_success'),
    [LogOperation.SYNC_FAILED]: Lang.t('log.sync_failed'),
    [LogOperation.SYNC_RECEIVED]: Lang.t('log.sync_received'),
    [LogOperation.OUTSEND_SYNC_SUCCESS]: Lang.t('log.outsend_sync_success'),  // 新增
    [LogOperation.OUTSEND_SYNC_FAILED]: Lang.t('log.outsend_sync_failed'),   // 新增
    [LogOperation.SYNC_SKIPPED]: Lang.t('log.syncskip'),



    // 文件分享权限相关操作
    [LogOperation.SET_PUBLIC_READONLY]: Lang.t('log.set_public_readonly'),
    [LogOperation.SET_PUBLIC_FULL]: Lang.t('log.set_public_full'),
    [LogOperation.SET_PRIVATE_READONLY]: Lang.t('log.set_private_readonly'),
    [LogOperation.SET_PRIVATE_FULL]: Lang.t('log.set_private_full'),
    [LogOperation.REMOVE_SHARE]: Lang.t('log.remove_share'),
    [LogOperation.PREVIEW_SHARE_FILE]: Lang.t('log.preview_share_file'),

    // 分享查看相关操作类型（根据实际需要保留）
    [LogOperation.VIEW_PUBLIC_SHARE_DETAIL]: Lang.t('log.view_public_share_detail'),
    [LogOperation.VIEW_PRIVATE_SHARE_OWNER]: Lang.t('log.view_private_share_owner'),
    [LogOperation.VIEW_PRIVATE_SHARE_TARGET]: Lang.t('log.view_private_share_target'),
    [LogOperation.VIEW_MY_SHARES]: Lang.t('log.view_my_shares'),
    [LogOperation.VIEW_SHARES_SHARED_TO_ME]: Lang.t('log.view_shares_shared_to_me'),
    [LogOperation.BROWSE_SHARE]: Lang.t('log.browse_share'),
    [LogOperation.DOWNLOAD_SHARE_ZIP]: Lang.t('log.download_share_zip'),
    [LogOperation.BROWSE_SHARE_FILES]: Lang.t('log.browse_share_files'),
    [LogOperation.DOWNLOAD_SHARE_FILE]: Lang.t('log.download_share_file'),
  };
  return operationMap[operation] || operation;
}
  // 获取目标类型的中文显示
  getTargetTypeText(targetType: string): string {
    const targetTypeMap: { [key: string]: string } = {
      [LogTargetType.MATTER]: Lang.t('log.matter'),
      [LogTargetType.DIRECTORY]: Lang.t('log.directory'),
      [LogTargetType.SHARE]: Lang.t('matter.share'),
    };
    return targetTypeMap[targetType] || targetType;
}

  // 获取操作图标类名（用于前端显示）
  getOperationIconClass(): string {
    const iconMap: { [key: string]: string } = {
      [LogOperation.UPLOAD]: 'anticon-upload',
      [LogOperation.DELETE]: 'anticon-delete',
      [LogOperation.SOFT_DELETE]: 'anticon-delete',
      [LogOperation.RECOVERY]: 'anticon-eye',
      [LogOperation.DOWNLOAD]: 'anticon-download',
      [LogOperation.RENAME]: 'anticon-edit',
      [LogOperation.MOVE]: 'anticon-export',
      [LogOperation.COPY]: 'anticon-copy',
      [LogOperation.CREATE_DIRECTORY]: 'anticon-folder-add',
    };
    return iconMap[this.operation] || 'anticon-eye';
  }

  // 获取格式化后的创建时间
  getFormattedCreateTime(): string {
    return DateUtil.simpleDateTime(this.createTime);
  }

  // 获取简化的详情显示（用于表格中显示）
  getSimplifiedDetail(maxLength: number = 50): string {
    if (!this.detail) return '';
    if (this.detail.length <= maxLength) return this.detail;
    return this.detail.substring(0, maxLength) + '...';
  }

  // 获取用户显示信息
  getUserDisplay(): string {
    return this.username || this.userUuid?.substring(0, 8) + '...' || 'Unknown User';
  }

  // 获取空间显示信息
  getSpaceDisplay(): string {
    return this.spaceName || this.spaceUuid?.substring(0, 8) + '...' || 'Unknown Space';
  }

  // 获取目标显示信息
  getTargetDisplay(): string {
    return this.targetName || this.targetUuid?.substring(0, 8) + '...' || '未知目标';
  }

  httpDetail(
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    if (!this.uuid) {
      this.errorMessage = 'uuid未指定，无法获取到详情！';
      this.defaultErrorHandler(this.errorMessage, errorCallback);
      return;
    }

    this.detailLoading = true;

    this.httpGet(
      this.getUrlDetail(),
      {
        uuid: this.uuid,
      },
      function (response: any) {
        that.detailLoading = false;
        that.assign(response.data.data);
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (response: any) {
        that.detailLoading = false;
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(response), response);
        } else {
          that.defaultErrorHandler(response);
        }
      },
      finallyCallback
    );
  }

  getFilters(): Filter[] {
    // 将 LogOperation 枚举转换为选项数组，只包含 name 属性
    const operationOptions = Object.values(LogOperation).map(value => ({
      value: value,
      name: this.getOperationText(value) // 只包含 name 属性
    }));
  
    // 将 LogTargetType 枚举转换为选项数组，只包含 name 属性
    const targetTypeOptions = Object.values(LogTargetType).map(value => ({
      value: value,
      name: this.getTargetTypeText(value) // 只包含 name 属性
    }));
  
    return [
      ...super.getFilters(),
      new InputFilter(Lang.t('user.username'), 'username', Lang.t('user.usernamesearch')),
      new InputFilter(Lang.t('space.spaceName'), 'spaceName', Lang.t('space.spaceNameSearch')),
      new SelectionFilter(Lang.t('log.operation'), 'operation', operationOptions),
      new SelectionFilter(Lang.t('matter.type'), 'targetType', targetTypeOptions),  
      new InputFilter(Lang.t('log.objectName'), 'targetName'),
      new InputFilter('IP', 'ip'),
      new SortFilter(Lang.t('createTime'), 'orderCreateTime'),

    ];
  }

  // 清理过期日志
  httpClean(
    keepDays: number,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {    
    const url = `${EnvUtil.currentHost()}${this.getUrlPrefix()}clean/expired`;
    this.httpPost(     
      url,
      { keepDays },
      successCallback,
      errorCallback,
      finallyCallback
    );
  }

// 导出日志（基于筛选条件）
httpExport(
  params: any,
  successCallback?: any,
  errorCallback?: any,
  finallyCallback?: any
) {
  const url = `${EnvUtil.currentHost()}${this.getUrlPrefix()}export`;
  // 使用 httpPost 并传入配置 { responseType: 'blob' }，让底层 axios 返回 Blob
  this.httpPost(
    url,
    params,
    (response: any) => {
      // 根据 BaseEntity 的实现，response 可能是 axios 响应对象或直接是数据
      let blob: Blob;
      if (response.data instanceof Blob) {
        blob = response.data;
      } else if (response instanceof Blob) {
        blob = response;
      } else {
        console.error('导出响应不是 Blob', response);
        if (errorCallback) errorCallback('导出响应格式错误');
        return;
      }
      // 触发浏览器下载
      const link = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = `logs_${DateUtil.simpleDateTime(new Date())}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
      SafeUtil.safeCallback(successCallback)(response);
    },
    errorCallback,
    finallyCallback,
    { responseType: 'blob' } // 传递给 axios 的配置
  );
}
  getUrlPrefix() {
    return '/api/log/';
  }

  // 获取列表URL（重写以符合后端API）
  getUrlList(): string {
    return `${EnvUtil.currentHost()}${this.getUrlPrefix()}page`;
  }

  // 获取详情URL（重写以符合后端API）
  getUrlDetail(): string {
    return `${EnvUtil.currentHost()}${this.getUrlPrefix()}detail`;
  }

  // 验证过滤器
  validateFilter(): boolean {
    // 这里可以添加特定的验证逻辑
    return true;
  }

  // 静态方法：获取所有操作类型选项（用于下拉选择）
  static getOperationOptions(): { value: string; label: string }[] {
    return [
      { value: LogOperation.UPLOAD, label: Lang.t('log.upload') },
      { value: LogOperation.DELETE, label: Lang.t('log.delete') },
      { value: LogOperation.SOFT_DELETE, label: Lang.t('log.softDelete') },
      { value: LogOperation.RECOVERY, label: Lang.t('log.recovery') },
      { value: LogOperation.DOWNLOAD, label: Lang.t('log.download') },
      { value: LogOperation.RENAME, label: Lang.t('log.rename') },
      { value: LogOperation.MOVE, label: Lang.t('log.move') },
      { value: LogOperation.COPY, label: Lang.t('log.copy') },
      { value: LogOperation.CREATE_DIRECTORY, label: Lang.t('log.createDirectory') },
    ];
}

  // 静态方法：获取所有选项（用于下拉选择）
  static getTargetTypeOptions(): { value: string; label: string }[] {
    return [
      { value: LogTargetType.MATTER, label: Lang.t('log.matter') },
      { value: LogTargetType.DIRECTORY, label: Lang.t('log.directory') },
    ];
}
}